<template>
    <div>
        <div class='map' ref='google-map'></div>
    </div>
</template>
<script>
// import gmapstyle from '@/config/gmapstyle';
import gmapstyleDarkTheme from '@/config/gmapstyle_dark_theme.js';

export default {
    name: 'google-map',

    props: {
        markers: {
            type: [Array, Object],
            default() {
                return [] || {};
            },
        },

        zoom: {
            type: Number,
            default: 16,
        },

        options: {
            type: Object,
            default() {
                return {
                    disableDefaultUI: true,
                    panControl: false,
                };
            },
        },
    },

    data() {
        return {
            map: null,
        };
    },

    mounted() {
        this.initMap();
    },

    methods: {
        initMap() {
            const mapElement = this.$refs['google-map'];
            /* eslint-disable */
            this.map = new google.maps.Map(mapElement, {
                center: { lat: 0, lng: 0 },
                zoom: this.zoom,
                styles: gmapstyleDarkTheme,
                backgroundColor: 'none',
                ...this.options,
            });

            this.renderMarkers();
        },

        renderMarkers() {
            let latLng = {
                lat: this.markers.latitude * 1,
                lng: this.markers.longitude * 1,
            };

            new google.maps.Marker({
                position: latLng,
                map: this.map,
                title: this.markers.name,
                icon: require('@/assets/img/icons8-marker-30.png'),
            });

            this.map.setCenter(latLng);
        },
    },
};
</script>

<style lang="scss" scoped>
.map {
    width: 100%;
    height: 207px;
    @include media-breakpoint-up(md) {
        height: 260px;
    }
}
</style>

